module.exports = __webpack_public_path__ + "img/f30efed.jpg";